import { useSearchParams } from "react-router";

export function useSearchParamsAsObject<T extends Record<string, any>>() {
  const [searchParams] = useSearchParams();
  const searchParamsObject = Object.fromEntries(searchParams.entries());
  return searchParamsObject as T;
}
